<template>
  <div class="box distance">
    <span class="title">{{ title }}</span>
    <div class="items">
      <span 
        v-for="(item, index) in data" 
        :key="index" 
        :class="{current: index === n}"
        @click="change(index)"
      >
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'data'],
  data() {
    return {
      n: '',
      value: ''
    }
  },
  watch: {
    n(val) {
      if (val === '') {
        this.value = ''
      }
    }
  },
  methods: {
    change(index) {
      if (this.n === index) {
        this.n = ''
      } else {
        this.n = index
        this.value = this.data[index].value
      }
    },
    reset() {
      this.n = ''
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  color: var(--grey);
  margin-bottom: 5px;
  .items {
    margin-top: 12px;
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    >span {
      width: 47%;
      height: 22px;
      text-align: center;
      line-height: 22px;
      border: 1px solid #F1F3F5;
      border-radius: 3px;
      margin-bottom: 12px;
    }
    .current {
      border-color: var(--blue);
      color: var(--blue);
    }
  }
}
</style>